// extracted by mini-css-extract-plugin
export default {"title":"Title_title__IlEm8","text_marked":"Title_text_marked__VeoT5"};